<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="fmtitle">CONTENTS</p>
<p class="tocc" id="intro"><a href="#/text/Introduction#aintro">Introduction</a></p>
<p class="tocf" id="ch1"><a href="#/text/Chapter001#ach1">808 Conversation Starters for Couples</a></p>
<p class="tocf" id="ack"><span href="#/text/Acknowledgments#aack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="tocf" id="ata"><span href="#/text/About_the_Author#aata" title="Link target outside of Sample">About the Author</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3d6ea37b